import React from 'react';
import styled from 'styled-components';

import flexGap from '../functions/flexGap';
import priceWithCurrency from '../functions/priceWithCurrency';

import { Title, Paragraph } from '../helpers/Text';
import Number from '../helpers/Number';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 35px;
`;

const Info = styled.div`
  display: flex;
  ${flexGap(5)};
`;

const Header = ({ order }) => {
  const discountTotal = (
    order?.discountCode?.amountFull
    || order?.discountCode?.amountShippingAndPaymentFull
  )
    ? order.cost.total
    : order.cost.total
      * (order?.discountCode?.amountPercentage / 100 || 0)
      - (order?.discountCode?.amountFixed || 0);

  const priceTotal = order.cost.total - discountTotal;

  return (
    <Wrapper>
      <Title bold style={{ margin: 0 }}>Cart</Title>
      <Paragraph opacity={0.5} fontSize={13} as="div">
        <Info>
          <Number
            key={order.items.length}
            number={`
              ${order.items.length}
              ${order.items.length === 1 ? 'item' : 'items'},
            `}
          />
          <Number
            key={order.cost.total}
            number={order.store.trn.active
              ? priceWithCurrency(priceTotal * 1.05, order.store)
              : priceWithCurrency(priceTotal, order.store)}
          />
        </Info>
      </Paragraph>
    </Wrapper>
  );
};

export default Header;
